import { render, staticRenderFns } from "./studentSelect.vue?vue&type=template&id=0747fcc5&scoped=true&"
import script from "./studentSelect.vue?vue&type=script&lang=ts&"
export * from "./studentSelect.vue?vue&type=script&lang=ts&"
import style0 from "./studentSelect.vue?vue&type=style&index=0&id=0747fcc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747fcc5",
  null
  
)

export default component.exports